export default __webpack_public_path__ + "static/media/icons-currency-ruby-sml.d373c407.png";